export default __webpack_public_path__ + "static/12-7887c275b5e1a97bb0fdbcf6fd032bef.jpg";